import { Box } from "@mui/material"
import { DataGridPremium, GridColDef, useGridApiRef } from "@mui/x-data-grid-premium"

import type { BulkLabel } from "@app/services/types"
import { LabelViewHeader } from "./LabelViewHeader"

export type ExportType = "excel" | "csv"

type LabelDataGridProps = {
	bulkLabels: BulkLabel[]
}

export const LabelDataGrid: React.FC<LabelDataGridProps> = ({ bulkLabels }) => {
	const apiRef = useGridApiRef()

	const columns: GridColDef[] = [
		{ field: "bulk_label", headerName: "Bulk ID", flex: 0.7, minWidth: 150 },
		{ field: "part_number", headerName: "Cat Class", flex: 1 },
		{ field: "description", headerName: "Description", flex: 2 },
	]

	const handleExportFile = (fileType: ExportType) => {
		const fileName = `bulk_labels_${new Date().toLocaleDateString()}`
		const exportParams = {
			fileName,
			getRowsToExport: () => bulkLabels.map((label) => label.bulk_label_id), // exporting all rows despite table filters
		}

		if (fileType === "excel") {
			apiRef.current?.exportDataAsExcel(exportParams)
		} else {
			apiRef.current?.exportDataAsCsv({
				...exportParams,
				utf8WithBom: true,
			})
		}
	}

	return (
		<Box sx={{ width: "100%", display: "flex", flexDirection: "column", minHeight: 0, flex: 1 }}>
			<Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
				<LabelViewHeader bulkLabels={bulkLabels} onExportFile={handleExportFile} />
			</Box>

			<Box
				sx={{
					flex: 1,
					minHeight: 0,
					overflow: "auto",
					width: "100%",
					minWidth: 0,
					height: 0,
				}}
			>
				<DataGridPremium
					apiRef={apiRef}
					rows={bulkLabels}
					columns={columns}
					getRowId={(row) => row.bulk_label_id}
					hideFooter
					sx={{
						maxHeight: 650,
						minWidth: 0,
						minHeight: 0,
						width: "100%",
						border: "none",
						"& .MuiDataGrid-columnSeparator": {
							display: "none",
						},
					}}
				/>
			</Box>
		</Box>
	)
}
export default LabelDataGrid
